import React, { useRef } from "react";
import { BackgroundColorIcon, PencilColorIcon } from "../../SVGIcons";

interface RectangleToolOptionsProps {
  rectFillEnabled: boolean;
  setRectFillEnabled: (enabled: boolean) => void;
  rectFillColor: string;
  setRectFillColor: (color: string) => void;
  rectStrokeEnabled: boolean;
  setRectStrokeEnabled: (enabled: boolean) => void;
  rectStrokeColor: string;
  setRectStrokeColor: (color: string) => void;
}

export const RectangleToolOptions: React.FC<RectangleToolOptionsProps> = ({
  rectFillEnabled,
  setRectFillEnabled,
  rectFillColor,
  setRectFillColor,
  rectStrokeEnabled,
  setRectStrokeEnabled,
  rectStrokeColor,
  setRectStrokeColor,
}) => {
  const rectFillColorInputRef = useRef<HTMLInputElement>(null);
  const rectStrokeColorInputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      {/* 塗り */}
      <div className="relative">
        <button
          onClick={() => {
            if (rectFillEnabled) {
              rectFillColorInputRef.current?.click();
            } else {
              setRectFillEnabled(true);
            }
          }}
          className={`p-1.5 rounded ${rectFillEnabled ? 'bg-gray-200' : 'hover:bg-gray-100 opacity-50'}`}
          title="塗りつぶし色"
        >
          <BackgroundColorIcon className="w-5 h-5" barColor={rectFillEnabled ? rectFillColor : '#cccccc'} />
        </button>
        <input
          ref={rectFillColorInputRef}
          type="color"
          value={rectFillColor}
          onChange={(e) => setRectFillColor(e.target.value)}
          style={{ position: 'absolute', top: '100%', left: 0, visibility: 'hidden' }}
        />
      </div>
      {rectFillEnabled && (
        <button
          onClick={() => setRectFillEnabled(false)}
          className="px-1.5 py-1 rounded text-xs hover:bg-gray-100 text-gray-600"
          title="塗りを無効にする"
        >
          ✕
        </button>
      )}

      {/* 枠線 */}
      <div className="relative">
        <button
          onClick={() => {
            if (rectStrokeEnabled) {
              rectStrokeColorInputRef.current?.click();
            } else {
              setRectStrokeEnabled(true);
            }
          }}
          className={`p-1.5 rounded ${rectStrokeEnabled ? 'bg-gray-200' : 'hover:bg-gray-100 opacity-50'}`}
          title="枠線色"
        >
          <PencilColorIcon className="w-5 h-5" barColor={rectStrokeEnabled ? rectStrokeColor : '#cccccc'} />
        </button>
        <input
          ref={rectStrokeColorInputRef}
          type="color"
          value={rectStrokeColor}
          onChange={(e) => setRectStrokeColor(e.target.value)}
          style={{ position: 'absolute', top: '100%', left: 0, visibility: 'hidden' }}
        />
      </div>
      {rectStrokeEnabled && (
        <button
          onClick={() => setRectStrokeEnabled(false)}
          className="px-1.5 py-1 rounded text-xs hover:bg-gray-100 text-gray-600"
          title="枠線を無効にする"
        >
          ✕
        </button>
      )}
    </>
  );
};

export default RectangleToolOptions;
